import config from 'config/environment';
import { useEffect, useState } from 'react';

export default function usePolling(callback, interval) {
  const [isPolling, setIsPolling] = useState(false);

  useEffect(() => {
    if (!isPolling) return;

    // Log the polling start time
    if (config.env === 'development' || config.env === 'staging') {
      console.log('Polling is set to start at', new Date().toISOString(), 'first check in', interval / 1000, 'seconds');
    }

    const intervalId = setInterval(callback, interval);

    return () => clearInterval(intervalId);
  }, [isPolling, callback, interval]);

  return { isPolling, setIsPolling };
}
